import React, { useState, useCallback } from 'react';
import { Tab } from 'semantic-ui-react';

import GuaranteePurchases from './GuaranteePurchases';
import CancelledGuaranteePurchases from './CancelledGuaranteePurchases';
import IneligiblePurchases from './IneligiblePurchases';
import GuaranteeProductSelector from '../components/GuaranteeProductSelector';
import GuaranteePanel from '../components/GuaranteePanel';
import { GUARANTEES_V2_ENABLED } from '../config';
import { useGuaranteeTheme } from '../hooks/useGuaranteePurchases';

const GuaranteePurchasesTabs = () => {
  const themeClass = useGuaranteeTheme();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabChange = useCallback((e, { activeIndex }) => {
    setActiveTabIndex(activeIndex);
  }, []);

  if (!GUARANTEES_V2_ENABLED) {
    const panes = [
      {
        menuItem: { key: 'guarantee', content: 'Guarantee Purchases', 'data-testid': 'tab-guarantee' },
        render: () => (
          <Tab.Pane>
            {' '}
            <GuaranteePurchases />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { key: 'cancelled', content: 'Canceled Purchases', 'data-testid': 'tab-cancelled' },
        render: () => (
          <Tab.Pane>
            <CancelledGuaranteePurchases />
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div data-testid='guarantees-tabs'>
        {' '}
        <Tab panes={panes} />
      </div>
    );
  }

  const panes = [
    {
      menuItem: { key: 'guarantee', content: 'Guarantee Purchases', 'data-testid': 'tab-guarantee' },
      render: () => (
        <Tab.Pane>
          <GuaranteePurchases />
        </Tab.Pane>
      ),
    },
    {
      menuItem: { key: 'cancelled', content: 'Cancelled Purchases', 'data-testid': 'tab-cancelled' },
      render: () => (
        <Tab.Pane>
          <CancelledGuaranteePurchases />
        </Tab.Pane>
      ),
    },
    {
      menuItem: { key: 'ineligible', content: 'Ineligible Purchases', 'data-testid': 'tab-ineligible' },
      render: () => (
        <Tab.Pane>
          <IneligiblePurchases />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div
      data-testid='guarantees-tabs'
      style={{ marginTop: '-56px' }}
      className={themeClass}
    >
      <GuaranteePanel>
        <GuaranteeProductSelector />
      </GuaranteePanel>
      <Tab
        panes={panes}
        activeIndex={activeTabIndex}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

export default GuaranteePurchasesTabs;
